import {get, post} from '@/lib/axios';

export default {
    async changeDealerBrand(data) {
        return post('/account/change-dealer-brand', data)
    }
}